import { useSelector } from "react-redux";
import { IReduxState } from "../state/reducers/root.reducer";

export const useIsWebExtension = () => {
  return useSelector((state: IReduxState) => state.webExtension.isWebExtension);
};

export default useIsWebExtension;
